import { useMemo } from 'react'

import { useTimeZone } from '../components/time-zone-provider.tsx'
import {
  searchDateRange,
  type SearchDateRange
} from '../lib/search-date-range.ts'

/** Resolve a search range once per question and reader zone. */
export function useSearchDateRange(question: string): SearchDateRange {
  const { timeZone } = useTimeZone()
  return useMemo(
    () => searchDateRange(question, { timeZone, now: new Date() }),
    [question, timeZone]
  )
}
